// Типы для авторизации и пользователей

export enum UserType {
  USER = 'user',
  MANAGER = 'manager'
}

export enum ManagerRole {
  CURATOR = 'curator',
  ADMIN = 'admin', 
  BUSINESS = 'business',
  EDUCATION = 'education',
  PLATFORM_CURATOR = 'PlatformCurator',
  ORGANIZATION_MANAGER = 'OrganizationManager'
}

export enum UserStatus {
  TEMP = 'temp',
  SELFEMPLOYED = 'selfemployed',
  INACTIVE = 'inactive',
  BLOCKED = 'blocked'
}

export interface User {
  id: string;
  phone: string;
  status: UserStatus;
  personalData?: any;
  cityId?: string;
  canTakeTasks: boolean;
  telegramId?: number;
  createdAt: string;
}

export interface Manager {
  id: string;
  phone: number; // Изменяем на number
  status: string;
  roles: string[]; // Изменяем на string[]
  avatar?: string;
  verticalId?: string;
  telegramId?: number;
  organizationId?: string;
  fullName?: string; // Добавляем
  tasks?: any[]; // Добавляем
  organizations?: any[]; // Добавляем
}

export interface AuthUser {
  type: UserType;
  user?: User;
  manager?: Manager;
  accessToken: string;
  refreshToken: string;
  isOrganizationManager?: boolean; // Добавляем флаг для менеджера организации
}

export interface LoginCredentials {
  phone: number;
  authToken?: string;
}

export interface VerifyCredentials {
  phone: number;
  code: string;
  challengeToken?: string;
}

export interface AuthResponse {
  result: string;
  accessToken?: string;
  refreshToken?: string;
  challengeToken?: string;
  url?: string;
  user?: User;
  manager?: Manager;
}

// Состояние авторизации
export interface AuthState {
  user: AuthUser | null;
  isLoading: boolean;
  error: string | null;
}

// Типы для выбора роли
export interface UserTypeOption {
  type: 'executor' | 'business';
  title: string;
  description: string;
  icon: string;
}
